var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "featured-goc",
      on: {
        click: function($event) {
          return _vm.selectGOC()
        }
      }
    },
    [
      _vm.isLoading
        ? _c("div", [_vm._m(0)])
        : _c("img", {
            staticClass: "lazyload featured-image",
            attrs: { src: _vm._f("getProductImage")(_vm.goc) }
          }),
      _vm._v(" "),
      _c("p", { staticClass: "happybox-button white border" }, [
        _vm._v("View " + _vm._s(_vm.goc.category) + " Collection")
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spinner-container" }, [
      _c("div", { staticClass: "spinner" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }